import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { fieldRendersMainJSXForImports } from './field-renders-main-jsx-for-imports.js'
import { fieldSupportsIconPostfix } from './field-supports-icon-postfix.js'

export function hasRenderedIconPostfix(fields: SchemaField[]): boolean {
  for (const field of fields) {
    if (field.hidden) continue
    if (field.hasIcon && fieldSupportsIconPostfix(field) && fieldRendersMainJSXForImports(field)) {
      return true
    }
    if ((field.type === 'group' || field.type === 'section') && field.fields) {
      if (hasRenderedIconPostfix(field.fields)) return true
    }
    if (field.type === 'tabs' && field.tabs) {
      for (const tab of field.tabs) {
        if (hasRenderedIconPostfix(tab.fields ?? [])) return true
      }
    }
  }
  return false
}
